import Auth from '@js/plugins/auth';

export default {
    computed: {
        canManageStaff() {
            return Auth.hasPermissionTo('franchise_manage_staff');
        },

        canCreateStaff() {
            return Auth.hasPermissionTo('franchise_create_staff');
        },

        canUpdateStaff() {
            return Auth.hasPermissionTo('franchise_update_staff');
        },

        canDeleteStaff() {
            return Auth.hasPermissionTo('franchise_delete_staff');
        },
    },

    methods: {
        canEditStaff(u) {
            if (u.id) {
                return this.canManageStaff || this.canUpdateStaff;
            } else {
                return this.canManageStaff || this.canCreateStaff;
            }
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/staff/staff-permission.js